import { render, staticRenderFns } from "./batchAuditModal.vue?vue&type=template&id=fa9b534c&scoped=true"
import script from "./batchAuditModal.vue?vue&type=script&lang=js"
export * from "./batchAuditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9b534c",
  null
  
)

export default component.exports